import React from 'react';
import AsyncCoinImage from '../../images/async_coin.png';
import NavigationInformation from './NavigationInformation';
import TransactionsInProgress from '../TransactionsInProgress';
import NavigationMenu from './NavigationMenu';
import { RESET_TUTORIAL_STATE } from '../../storage/TutorialReducer';

export default class Navigation extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      menuOpened: false
    };
  }

  toggleMenu = () => {
    this.setState({menuOpened: !this.state.menuOpened});
  };

  getNavigationBodyClass () {
    if (this.state.menuOpened) {
      return 'c-navigation__body c-navigation__body--opened';
    }

    return 'c-navigation__body';
  }

  closeMenu = () => {
    this.setState({menuOpened: false});
  };

  resetTutorial = () => {
    Storage.dispatch({type: RESET_TUTORIAL_STATE});
  };

  render () {
    return (
      <div className="c-navigation">
        <div className="c-navigation__header">
          <div className="c-navigation__branding-container">
            <img role="presentation" src={AsyncCoinImage} className="c-navigation__logo"/>
            <div className="c-navigation__branding-title">AsyncCoin</div>
          </div>
          <div className="c-navigation__toggle-menu" onClick={this.toggleMenu}></div>
        </div>
        <div className={this.getNavigationBodyClass()}>
          <NavigationInformation/>
          <NavigationMenu closeMenu={this.closeMenu} resetTutorial={this.resetTutorial}/>
          <TransactionsInProgress/>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Components/Navigation.js